import { IOrder } from './Order';
import { IUser } from './UserModel';

export interface IAddDepositRequest {
  sellerId: string;
  amount: number;
  notes?: string;
}

export interface IDeductDepositRequest {
  sellerId: string;
  amount: number;
  orderId?: string;
  notes?: string;
}

export enum DepositTransactionType {
  DEPOSIT = 'deposit',
  DEDUCTION = 'deduction',
}

export interface IDepositTransaction {
  id: string;
  seller: IUser;
  type: DepositTransactionType;
  amount: number;
  order?: IOrder;
  createdAt: Date;
  createdBy: IUser;
  notes?: string;
}
